import * as a from "react";
const t = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M21.17 2.79a1 1 0 011.04 1.04v.01l-.003.05-.013.285-.006.112.022-.447a15.523 15.523 0 01-.136 1.583 15.934 15.934 0 01-3.543 8.045l-.001 3.892h.01a1 1 0 01-.3.71L14 22.31a1 1 0 01-1.7-.7v-3.58l-.167.067-.323.123a.996.996 0 01-.237.056l-.12.006a1 1 0 01-.813-.432 14.1 14.1 0 00-3.5-3.5 1 1 0 01-.36-1.16c.06-.162.122-.322.187-.48H3.38A1 1 0 012.7 11l4.24-4.24a1 1 0 01.7-.3h3.904a15.929 15.929 0 019.626-3.67zM7.36 15.76h.01a16.203 16.203 0 011.87 1.87 1 1 0 01-.47 1.6c-.79.25-1.6.42-2.4.54a1 1 0 01-1.14-1.13c.12-.82.3-1.62.53-2.41a1 1 0 011.6-.47zm10.18-8.29a2.001 2.001 0 10-2.83 2.83 2.001 2.001 0 002.83-2.83z",
      fill: "#2d6ded"
    }
  )
), l = t;
export {
  l as default
};
